import { S } from '@angular/cdk/keycodes';
import { Pipe, PipeTransform } from '@angular/core';
import { Group } from 'ng2-dragula';
import { SITE_NAME, SITE_UUID } from 'src/environments/environment';

@Pipe({
    name: 'groupnames'
  })
export class GroupNames implements PipeTransform{



    transform(group: string) {

      
        let siteName =group.slice(5);
  
        if(siteName.includes('SiteManager')){
      
             siteName = siteName.substring(0, siteName.length - 12);
        }

        if(group == "ALFRESCO_ADMINISTRATORS"){
            return ;
        }else if(group == "ALFRESCO_MODEL_ADMINISTRATORS" || group == "ALFRESCO_SEARCH_ADMINISTRATORS" || group == "site_" + siteName ){
             return
        }else if (group == "EMAIL_CONTRIBUTORS"){
            return "Contributeur de mail"
        }else if (group == "SITE_ADMINISTRATORS"){
            return  "Administrateur du site"
        }else if(group == "site_" + siteName + "_SiteManager"){
            return "Manager de " + siteName;
        }else if(group == "site_" + siteName + "_SiteConsumer"){
            return "Consommateur de " + siteName;
        }else if(group == "site_" + siteName + "_SiteCollaborator"){
            return "Collaborateur de " + siteName;
        }else if(group == "site_" + siteName + "_SiteContributor"){
            return "Contributeur de " + siteName;
        }else if(group == "SiteManager"){
            return "Manager du site ";
        }else if(group == "SiteConsumer"){
            return "Consommateur du site";
        }else if(group == "SiteCollaborator"){
            return "Collaborateur du site";
        }else if(group == "SiteContributor"){
            return "Contributeur du site";
        }else{
            return group;
        }

    }
    
}